import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Commitment = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0%" }} data-aos={"fade-up"}>
      <Typography
        variant="h3"
        fontWeight={700}
        color={"#39484E"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        textAlign={"center"}
      >
        Our Committment
      </Typography>
      <Typography variant="h6" color={"#000"} textAlign={"center"}>
        AIR Fund is a catalyst for a future where resilience is not just an
        aspiration but a reality shared by empowered communities. By
        prioritizing locally driven solutions, leveraging advanced technologies,
        and addressing systemic inequities, AIR Fund seeks to redefine Africa’s
        development narrative, ensuring a legacy of self-sufficiency,
        innovation, and sustainable growth.
      </Typography>
    </Box>
  );
};

export default Commitment;
